import {
  Abril_Fatface,
  Bebas_Neue,
  Caveat,
  Dancing_Script,
  Montserrat,
  Oswald,
  Pacifico,
  Playfair_Display,
  Source_Sans_3,
} from "next/font/google";

const sourceSans = Source_Sans_3({
  subsets: ["latin"],
  variable: "--font-text-source-sans",
  weight: ["400", "500", "600", "700", "800", "900"],
  display: "swap",
});

const montserrat = Montserrat({
  subsets: ["latin"],
  variable: "--font-text-montserrat",
  weight: ["400", "500", "600", "700", "800", "900"],
  display: "swap",
});

const oswald = Oswald({
  subsets: ["latin"],
  variable: "--font-text-oswald",
  weight: ["400", "500", "600", "700"],
  display: "swap",
});

const playfairDisplay = Playfair_Display({
  subsets: ["latin"],
  variable: "--font-text-playfair",
  weight: ["400", "500", "600", "700", "800", "900"],
  display: "swap",
});

const bebasNeue = Bebas_Neue({
  subsets: ["latin"],
  variable: "--font-text-bebas",
  weight: "400",
  display: "swap",
});

const abrilFatface = Abril_Fatface({
  subsets: ["latin"],
  variable: "--font-text-abril-fatface",
  weight: "400",
  display: "swap",
});

const caveat = Caveat({
  subsets: ["latin"],
  variable: "--font-text-caveat",
  weight: ["400", "500", "600", "700"],
  display: "swap",
});

const dancingScript = Dancing_Script({
  subsets: ["latin"],
  variable: "--font-text-dancing-script",
  weight: ["400", "500", "600", "700"],
  display: "swap",
});

const pacifico = Pacifico({
  subsets: ["latin"],
  variable: "--font-text-pacifico",
  weight: "400",
  display: "swap",
});

export const textFontVariablesClassName = [
  sourceSans.variable,
  montserrat.variable,
  oswald.variable,
  playfairDisplay.variable,
  bebasNeue.variable,
  abrilFatface.variable,
  caveat.variable,
  dancingScript.variable,
  pacifico.variable,
].join(" ");
